import React from "react";
import styled, { keyframes } from "styled-components";
import TagManager from "react-gtm-module";
import { devices, Container, ContentWrapper, ButtonPrimary, ButtonSecondary } from "../../styles";
import { dictionary } from "../../contexts/site";

export default function ResetModal({showResetModal, setShowResetModal, resetProgress}) {

  return showResetModal ? (
    <Container>
    <MobWrapper>
      <RestartWrapper>

        <h1 className="fadeIn" dangerouslySetInnerHTML={{__html: dictionary.start.title}} />
        <p style={{"fontSize" : "21px", "lineHeight": "30px", "fontWeight": "300"}} 
          className="fadeIn" dangerouslySetInnerHTML={{__html: dictionary.start.restartPara}} />

        <hr className="fadeIn" />
          
        <ButtonsContainer>

          <ButtonPrimary 
            light 
            dangerouslySetInnerHTML={{__html: dictionary.buttons.giveUp}} 
            onClick={() => {
              // analytics for clicking no button
              const tagManagerArgs = {
                dataLayer: {
                  event: "gaQuizEvent",
                  eventAction: `${name}`,
                  eventLabel: `Restart Button - Yes`,
                },
              };
              TagManager.dataLayer(tagManagerArgs);
              setShowResetModal(false);
              resetProgress();
            }} />
          <ButtonSecondary 
            style={{"marginTop" : "0"}}
            light 
            dangerouslySetInnerHTML={{__html: dictionary.buttons.never}} 
            onClick={() => {
              // analytics for clicking no button
              const tagManagerArgs = {
                dataLayer: {
                  event: "gaQuizEvent",
                  eventAction: `${name}`,
                  eventLabel: `Restart Button - No`,
                },
              };
              TagManager.dataLayer(tagManagerArgs);
              setShowResetModal(false)
            }} />
          </ButtonsContainer>

      </RestartWrapper>

    </MobWrapper>
  </Container>
  ) : null;
}

const RestartWrapper = styled(ContentWrapper)`
  background-color: rgba(65, 84, 100, 0.9);
  //color: ${({ theme }) => theme.light};
  text-align: center;
  margin-left: 0;
  margin-right: 0;
  height: 100%;
  
  @media ${devices.M} {
    margin-left: 58px;
    margin-right: 58px;
  }

  @media ${devices.L} {
    margin-left: 0;
  }



  &::before {
    background-color: rgba(14,56,89,0.75);
    content: "";
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0;
    left: 0px;
    z-index: -1;
    //height: 100vh;
  }

  hr {
    background-color: ${({ theme }) => theme.border};
    border: none;
    height: 1px;
    width: 40px;
    margin: 15px auto;

    @media ${devices.M} {
      margin: 20px auto;
    }
  }
  
  h1 {
    color: ${({ theme }) => theme.primary};
    display: inline-block;
    font-size: 22px;
    font-weight: 800;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: center;
    text-transform: uppercase;

    @media ${devices.M} {
      font-size: 26px;
      line-height: 30px;
    }

    @media ${devices.L} {
      max-width: 442px;
    }
  }

  p {
    font-size: 14px;
    line-height: 1.63;
    margin: 30px 0 0;

    @media ${devices.M} {
      line-height: 1.5;
    }
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;

  button {
    min-width: 260px;
  }

  ${ButtonPrimary}:not(:last-child) {
    margin-bottom: 16px;
    @media ${devices.S} {
      margin-bottom: 15px;
    }
  }
`;

const MobWrapper = styled.div`
  @media ${devices.S} {
    height: 100%;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 2;
  }
`;